import { R } from 'core/helpers'

import getFocusableElements from './getFocusableElements'
import getNodes from './getNodes'

const focusFirstFocusableItem = (...nodesOrRefs) => {
  const nodes = getNodes(nodesOrRefs)
  for (const node of nodes) {
    const els = getFocusableElements(node)
    const first = R.first(els)
    if (first) {
      try {
        first.focus()
      } catch {
        // Ignore error
      }
      return
    }
  }
}

export default focusFirstFocusableItem
